import Icon from '@icon/Icon';

const Practice = (props) => {
  const { color, ...rest } = props;

  return (
    <Icon {...rest} viewBox="0 0 32 32">
      <circle
        cx="16.0003"
        cy="15.9998"
        r="9.33333"
        fill="#7260E0"
        fillOpacity="0.2"
      />
      <path
        d="M19.0937 4.63159C19.0937 4.3784 18.934 4.14967 18.6881 4.05049C18.4422 3.95131 18.1576 4.00084 17.9649 4.17633L15.5943 6.33579C12.0647 9.55104 9.08224 13.265 6.75313 17.3454C6.6983 17.4372 6.66699 17.5432 6.66699 17.6562C6.66699 18.005 6.96547 18.2878 7.33366 18.2878H13.0803V27.3684C13.0803 27.6185 13.2361 27.8451 13.4776 27.9461C13.7191 28.0472 14.0008 28.0037 14.1959 27.8353L15.2566 26.92C18.9696 23.7157 22.1206 19.9721 24.5913 15.8295L25.2474 14.7295C25.364 14.5339 25.3623 14.2944 25.2428 14.1004C25.1233 13.9065 24.9041 13.7872 24.667 13.7872H19.0937V4.63159Z"
        fill="#7260E0"
      />
    </Icon>
  );
};

export default Practice;
